import { type PropsWithChildren, type FC } from 'react';

import { useCustomStyles } from './Wave.styles';

type Props = { isFlipped?: boolean; className?: string };

export const Wave: FC<Props> = ({ isFlipped, className }) => {
	const { classes, cx } = useCustomStyles();

	return (
		<svg
			className={cx(classes.wave, { [classes.flipped]: isFlipped }, className)}
			viewBox="0 0 1440 46"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g transform="scale(1 .74262)">
				<path
					d="M0 59.2h80.4c79.2 0 240 0 399.6-7.2 159.6-7.2 320.4-21.6 480-28.8 159.6-7.2 320.4-7.2 399.6-7.2h80.4v46L0 61.987V59.2Z"
					fill="currentColor"
					transform="matrix(1 0 0 1.34658 0 -21.142)"
				/>
			</g>
		</svg>
	);
};

export const WaveWrapper: FC<PropsWithChildren<Props>> = ({ children }) => {
	const { classes } = useCustomStyles();
	return (
		<div className={classes.waveContainer}>
			<Wave />
			<div className={classes.waveContent}>{children}</div>
			<Wave isFlipped={true} />
		</div>
	);
};
